<script>
    import { onMount } from "svelte";
    onMount(async () => {
        // svelte:body doesn't work
        document.documentElement.setAttribute("data-bs-theme", "light");
        document.body.className =
            "layout-fixed sidebar-expand-lg sidebar-mini bg-body-primary";
        document.documentElement.style.colorScheme = "light";
    });
</script>
<div class="app-wrapper">
    <div id="login-content-wrapper"><slot /></div>
</div>

<style>
    #login-content-wrapper {
        margin-left: 0;
        grid-column: 1 / -1; /* Spans from the first column line to the last */
        grid-row: 1 / -1;
    }
</style>
